/**
 * House style for inline text links in the members app: Satyrs yellow rather
 * than the blue `text-primary` token (which is reserved for buttons/branding).
 * yellow-700 keeps AA contrast on the light background; yellow-400 on dark.
 */
export const TEXT_LINK_CLASS = "font-medium text-yellow-700 hover:underline dark:text-yellow-400";
